var _excluded = ["isOpen", "getInputProps", "getComboboxProps", "openMenu"],
    _excluded2 = ["style", "css"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import { Control, Placeholder, SearchInput } from '../layout';

var AutocompleteControl = function AutocompleteControl(_ref) {
  var isOpen = _ref.isOpen,
      getInputProps = _ref.getInputProps,
      _getComboboxProps = _ref.getComboboxProps,
      openMenu = _ref.openMenu,
      props = _objectWithoutProperties(_ref, _excluded);

  var _getInputProps = getInputProps({
    readOnly: !isOpen
  }),
      inputStyle = _getInputProps.style,
      _ignored = _getInputProps.css,
      inputProps = _objectWithoutProperties(_getInputProps, _excluded2);

  return /*#__PURE__*/React.createElement(Control, _extends({
    isOpen: isOpen,
    renderInput: function renderInput() {
      return /*#__PURE__*/React.createElement(SearchInput, _extends({
        getComboboxProps: function getComboboxProps() {
          return _getComboboxProps({
            style: {
              flex: 1,
              display: 'flex',
              maxWidth: isOpen ? 'unset' : 0,
              opacity: isOpen ? 1 : 0
            }
          });
        },
        style: _objectSpread({}, inputStyle),
        isOpen: isOpen
      }, inputProps));
    },
    renderItem: isOpen ? function () {
      return null;
    } : undefined // undefined will use the default
    ,
    renderPlaceholder: function renderPlaceholder() {
      return isOpen ? null : /*#__PURE__*/React.createElement(Placeholder, null);
    },
    onClick: openMenu
  }, props));
};

AutocompleteControl.displayName = 'AutocompleteControl';
AutocompleteControl.propTypes = {
  /** Function to open menu.  Provided by useAutocomplete hook */
  openMenu: PropTypes.func.isRequired
};
export default AutocompleteControl;
//# sourceMappingURL=AutocompleteControl.js.map